// eBay Partner Network (EPN) Configuration
// Replace 'YOUR_CAMPAIGN_ID' with your actual eBay Ambassador Campaign ID

export const EPN_CONFIG = {
  // Your eBay Ambassador Campaign ID
  CAMPAIGN_ID: '5339120245', // Your actual Campaign ID
  
  // EPN tracking URL - Updated format
  TRACKING_URL: 'https://rover.ebay.com/rover/1/711-53200-19255-0/1',
  
  // Tool ID (usually 10001 for web applications)
  TOOL_ID: '10001',
  
  // Custom ID for tracking your website
  CUSTOM_ID: 'goatcards',
  
  // Website name for reporting
  WEBSITE_NAME: 'Goat Cards',
  
  // Enable/disable tracking (set to false to test without tracking)
  ENABLE_TRACKING: true,
};

// Instructions for setup:
// 1. Log into your eBay Ambassador account
// 2. Find your Campaign ID in the dashboard
// 3. Replace 'YOUR_CAMPAIGN_ID' with your actual Campaign ID
// 4. Save this file
// 5. Restart your development server
// 6. All eBay links will now include your tracking parameters 